import {Component} from '@angular/core';
import {BaseModalComponent} from "common-shared";
import {GraphModel} from "../models/graph.model";
import {Observable} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {GraphService} from "../graph.service";
import {GraphOptions} from "../models/graph-options";
import {ManufacturingItemModel} from "web-shared";
import {ManufacturingItemGroupService} from "../../manufactured-item-groups/manufacturing-item-group.service";
import {IntegratedMasterService} from "../../integrated-master-editor/services/integrated-master.service";
import {ManufacturingItemService} from "../../manufacturing-item/manufacturing-item.service";

@Component({
  selector: 'app-graph-builder-modal',
  templateUrl: './graph-builder-modal.component.html',
  styles: []
})
export class GraphBuilderModalComponent extends BaseModalComponent {
  graph: GraphModel;
  // itemGroup: ManufacturingItemGroupModel;
  item: ManufacturingItemModel;
  title: string;
  id: string;
  graphSource: 'Item' | 'ItemGroup' | 'Resource' | 'AllItems' = 'Item';
  options: GraphOptions;

  constructor(private graphService: GraphService, private manufacturedItemGroupService: ManufacturingItemGroupService, private manufacturingItemService: ManufacturingItemService, private integratedMasterService: IntegratedMasterService) {
    super();
  }

  ngOnInit() {
    this.load();
    this.loadGraph();
  }

  private load() {
    let loadItem$: Observable<ManufacturingItemModel>;
    switch (this.graphSource) {
      case "Item":
        loadItem$ = this.manufacturingItemService.loadOne(this.id).pipe(takeUntil(this.componentDestroyed));
        break;
    }

    loadItem$.subscribe(item => {
      this.item = item;
      this.integratedMasterService.getAll(null, this.item.Id).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        this.integratedMasterService.loadIme(this.item, value);
      });
    });
  }

  private loadGraph() {
    let loadGraph$: Observable<GraphModel>;
    switch (this.graphSource) {
      case "Item":
        loadGraph$ = this.graphService.getItemGraph(this.id, this.options);
        break;
    }

    loadGraph$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.graph = value;
      this.title ??= this.graph.Nodes.find(value => value.id === this.graph.Id).label;
    });
  }

  save(withClose: boolean = true) {
    this.manufacturingItemService.save(this.item).pipe(takeUntil(this.componentDestroyed)).subscribe({
      next: value => {
        this.item = value;
        if (withClose) {
          this.close();
        } else {
          this.item = value;
          this.integratedMasterService.getAll(null, this.item.Id).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
            this.integratedMasterService.loadIme(this.item, value);
          });
          this.loadGraph();
        }
      }
    });
  }
}
